import { connect } from 'react-redux';

import { setSwitchPfeSktAction } from '../actions/accountSettingsAction';
import { checkDailyQuizStatus } from '../actions/dailyQuizActions';
import { getDailyQuizHistoryAction } from '../actions/dashboardActions';
import {
  getSwitchPfeSkt,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import {
  getCheckDailyQuizStatusWaiting,
  getDailyQuizRunning,
  getNextQuizIn,
  getProgress,
} from '../components/Daily20Quiz/daily20QuizSelectors';
import DailyQuizPageView from '../components/DailyQuizPage/DailyQuizPageView';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  userSubscription: getUserSubscription(state),
  checkDailyQuizStatusWaiting: getCheckDailyQuizStatusWaiting(state),
  nextQuizIn: getNextQuizIn(state),
  dailyQuizRunning: getDailyQuizRunning(state),
  progress: getProgress(state),
  pfeSktId: getSwitchPfeSkt(state),
});

const mapDispatchToProps = (dispatch) => ({
  checkDailyQuizStatus: () => dispatch(checkDailyQuizStatus()),
  setSwitchPfeSkt: (rateId) => dispatch(setSwitchPfeSktAction(rateId)),
  refreshDailyQuizHistory: () =>
    dispatch(getDailyQuizHistoryAction(0, 3, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DailyQuizPageView);
